module.exports = __webpack_public_path__ + "img/768_banner_4.ace19868.jpg";